import { assetInfo, ActionType } from "./types"

const setAssetInfo = (data: assetInfo) => {
  return {
    type: ActionType.SET_ASSET_INFO,
    payload: data
  }
}

export default setAssetInfo
